// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bruteforcesettings-" + chunkId + ".js?v=" + {"node_modules_nextcloud_dialogs_dist_chunks_index-D5FJasts_mjs":"1cc6dd9f41b03ffddb72","vendors-node_modules_rehype-highlight_index_js":"7622b2cef8c7562b9826","vendors-node_modules_nextcloud_dialogs_dist_chunks_FilePicker-CvXU3iSt_mjs":"2df6b1e822cbeadc5ad1"}[chunkId] + "";
};